import styled from "styled-components";
import { css } from "@styled-system/css";
import { SpaceProps, space, TypographyProps, typography } from "styled-system";

import { MenuLink } from "../Navigation/MenuLink.type";
import { User } from "./bcaHeader.type";

import Icon from "../Icon/Icon";
import Box from "../Box/Box";
import Link from "../Link/Link";

interface MyBCAUserProps extends SpaceProps, TypographyProps {
  user?: User;
  accountLink?: MenuLink;
}

const UserBox = styled(Box)<SpaceProps>`
  display: flex;
  align-items: center;
  ${css({
    marginBottom: 4,
  })}
  ${space}
  ${typography}
`;

const UserAvatar = styled(Box)`
  align-items: center;
  justify-content: center;
  width: 56px;
  min-width: 56px;
  height: 56px;
  border-radius: 28px;
  border: 3px solid #fff;
  ${css({
    marginRight: 5,
    backgroundColor: "black",
    color: "primary-white",
    boxShadow: "hover",
    fontSize: 5,
    fontWeight: 2,
  })}
`;

const UserSettingsLink = styled(Link)`
  display: flex;
  align-items: center;
  ${css({
    fontWeight: "semiBold",
    color: "grey-blue",
    "&:hover": {
      color: "grey-blue",
    },
  })}
`;

const UserInfo = styled.span`
  ${css({
    display: "block",
    marginBottom: 1,
    fontFamily: "normal",
    color: "black",
    fontWeight: "semiBold",
    textDecoration: "none",
    lineHeight: 1.7,
  })};
`;

const MyBCAUser = ({ user, accountLink, ...props }: MyBCAUserProps) => {
  const userName = user?.firstName || user?.lastName;

  return (
    <UserBox {...props}>
      <UserAvatar display={{ _: "none", tablet: "flex" }}>
        {userName?.substring(0, 1)}
      </UserAvatar>
      <Box>
        <UserInfo>{`Welcome, ${userName}`}</UserInfo>
        {accountLink && (
          <UserSettingsLink
            key={accountLink.id}
            href={accountLink.link}
            underline="always"
          >
            <Icon name="cog" width={18} color="grey-blue" mr={2}></Icon>
            {accountLink.label}
          </UserSettingsLink>
        )}
      </Box>
    </UserBox>
  );
};

export default MyBCAUser;
